import { datadogLogs } from '@datadog/browser-logs';
import { BASE_URL } from '../constants';

function LogHelper() {
  this.isEnvDevelopment = process.env.NODE_ENV === 'development';
}

LogHelper.prototype.logError = function (error) {
  if (error && !error.isErrorFromApi) {
    if (this.isEnvDevelopment) {
      console.error(`%c ERROR :- ${error}`, 'background: black; color: red');
    } else {
      datadogLogs.logger.error(`Error(PWA): ${error}`, {
        errorDetails: error
      });
    }
  }
};

LogHelper.prototype.logInfo = function (info) {
  if (this.isEnvDevelopment) {
    console.log(`%c LOG :- ${info}`, 'background: black; color: yellow');
  } else {
    datadogLogs.logger.info(`Info Log(PWA) : ${info}`, { info });
  }
};

LogHelper.prototype.logAPIError = function ({
  error,
  url,
  params,
  headers,
  requestType
}) {
  if (this.isEnvDevelopment) {
    console.error(`%c API ERROR :-  ${error}`, 'background: black; color: red');
  } else {
    datadogLogs.logger.error(
      getDataDogTitle({ url, isErrorResponse: true, requestType }),
      {
        error,
        params,
        headers,
        requestType
      }
    );
  }
};

LogHelper.prototype.logAPISuccess = function ({
  data,
  url,
  params,
  headers,
  requestType
}) {
  if (this.isEnvDevelopment) {
    console.log(
      `%c API SUCCESS :- ${url}`,
      'background: black; color: #00FF00'
    );
    data && console.log(data);
  } else {
    datadogLogs.logger.info(
      getDataDogTitle({ url, isErrorResponse: false, requestType }),
      {
        data,
        params,
        headers,
        requestType
      }
    );
  }
};

LogHelper.prototype.logIndexedDBSuccess = function (message) {
  console.log(
    `%c INDEXED DB :- ${message}`,
    'background: black; color: #00FF00'
  );
};

LogHelper.prototype.logIndexedDBError = function logIndexedDBError(error) {
  console.log(`%c INDEXED DB :- ${error}`, 'background: black; color: red');
};

LogHelper.prototype.logStartOfNetworkRequest = function ({ url, params }) {
  console.log(`%c API REQUEST :- ${url}`, 'background: black; color: #FFA500');
  params && console.log(params);
};

function getDataDogTitle({ url, isErrorResponse, requestType }) {
  let title = url;
  if (!url.includes(BASE_URL)) {
    if (url.charAt(0) === '/') {
      title = url.substring(1);
    }
    title = `${BASE_URL}${title}`;
  }
  return isErrorResponse
    ? `API Error Response(PWA) : ${requestType} - ${title}`
    : `API Success Response(PWA) : ${requestType} - ${title}`;
}

export default new LogHelper();
